import type { Action, ActionType } from '../types.ts';

/**
 * Creates a default action with sensible initial values for the given action type.
 * Used when adding new actions to mappings, conditional branches, or array field mappings.
 */
export const createDefaultAction = (actionType: ActionType): Action => {
    switch (actionType) {
        case 'extract_source':
            return { action_type: 'extract_source', source: '' };
        case 'assign_literal':
            return { action_type: 'assign_literal', value: '' };
        case 'transform':
            return { action_type: 'transform', transformation_function: 'to_string' };
        case 'function_call':
            return { action_type: 'function_call', function_name: '' };
        case 'conditional':
            return {
                action_type: 'conditional',
                source: '',
                condition: { operator: 'equal', value: '' },
                true_actions: [],
            };
        case 'map_array':
            return {
                action_type: 'map_array',
                source: '',
                item_alias: 'item',
                field_mappings: [],
            };
        default:
            return { action_type: 'extract_source', source: '' };
    }
};
